import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { ListItem } from "./components";
import { useNotifications } from "src/hooks";
import { stringDateFullDynamicFormat } from "src/utils/date";
import { useNavigation } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export type NotificationsNavigationParam = undefined;

export const Notifications: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"Notifications">["navigation"]>();
  const [notifications] = useNotifications();

  return (
    <View style={styles.container}>
      <ScrollView>
        {notifications.map((item) => (
          <ListItem
            key={item.id}
            text={item.title}
            date={stringDateFullDynamicFormat(item.createdAt)}
            isNew={item.isUnread}
            onPress={() => navigation.push("Notification", { id: item.id })}
          />
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.gray1,
  },
});
